import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
const ContactPage = () => {
  const [emailHovered, setEmailHovered] = useState(false);
  const [hoverColor, setHoverColor] = useState('#FFA500'); // Default to orange
  const [filterValue, setFilterValue] = useState('');
  // Function to get a random orange or yellow color for the wavelet graphic
  const getRandomOrangeYellowColor = () => {
    const orangeYellowColors = [
    // Yellows
    '#FFFF00', '#FFFFE0', '#FFFACD', '#FAFAD2', '#FFEFD5', '#FFE4B5', '#FFDAB9', '#EEE8AA', '#F0E68C', '#BDB76B', '#FFD700',
    // Oranges
    '#FFA500', '#FF8C00', '#FF7F50', '#FF6347', '#FF4500', '#FFA07A', '#FF8C69', '#FA8072', '#E9967A', '#F08080', '#CD5C5C', '#FF6600', '#FF9900', '#FFCC00' // Gold (Websafe)
    ];
    return orangeYellowColors[Math.floor(Math.random() * orangeYellowColors.length)];
  };
  const handleEmailMouseEnter = e => {
    // Use orange/yellow colors for the wavelet graphic
    const randomColor = getRandomOrangeYellowColor();
    e.currentTarget.style.color = getRandomColor(); // Keep blue for the text
    setHoverColor(randomColor); // Set orange/yellow for the wavelet
    setEmailHovered(true);
  };
  const handleEmailMouseLeave = e => {
    e.currentTarget.style.color = '#333333';
    setEmailHovered(false);
  };
  // Calculate filter values to change the blue PNG to the target color
  useEffect(() => {
    if (emailHovered) {
      // Instead of using random hue rotation, use fixed values for orange/yellow hues
      // Orange/yellow hues are approximately in the 20-60 degree range
      const orangeYellowHueRotation = Math.floor(Math.random() * 40) + 20; // Random between 20-60 degrees
      setFilterValue(`hue-rotate(${orangeYellowHueRotation}deg) saturate(${1.5 + Math.random() * 0.5})`);
    }
  }, [hoverColor, emailHovered]);
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-147">
      <Header data-id="element-148" />
      <main className="flex min-h-screen pt-24 px-6" data-id="element-149">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-150">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-151">
            <Navigation data-id="element-152" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8 relative" data-id="element-153">
            <div className="max-w-2xl" data-id="element-154">
              <ul className="list-none leading-tight" data-id="element-155">
                <li className="mb-[0.2rem]" data-id="element-156">
                  <span className="mr-2" data-id="element-157">•</span>
                  <Link to="/stay-in-touch" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-158">
                    Stay in touch
                  </Link>
                </li>
                <li className="mb-[0.2rem]" data-id="element-159">
                  <span className="mr-2" data-id="element-160">•</span>
                  <a href="https://www.instagram.com/madeleinemorlet/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-161">
                    Instagram
                  </a>
                </li>
                <li className="mb-[0.2rem] relative" data-id="element-162">
                  <span className="mr-2" data-id="element-163">↓</span>
                  <a href="mailto:mm@madeleinemorlet.com" className="transition-colors duration-200" onMouseEnter={handleEmailMouseEnter} onMouseLeave={handleEmailMouseLeave} data-id="element-164">
                    mm@madeleinemorlet.com
                  </a>
                </li>
                <li className="mb-[0.2rem]" data-id="element-165">
                  <span className="mr-2" data-id="element-166">↓</span>
                  <a href="https://archive.kintzing.com/photographer/madeleine-morlet/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-167">
                    Licensing - Kintzing
                  </a>
                </li>
                <li className="mb-[0.2rem]" data-id="element-168">
                  <span className="mr-2" data-id="element-169">↓</span>
                  <a href="https://www.dowlingwalsh.com/artists/madeleine-morlet2" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-170">
                    Print Enquiries - Dowling Walsh Gallery
                  </a>
                </li>
              </ul>
            </div>
            {emailHovered && <div className="fixed right-0 top-1/2 transform -translate-y-1/2 z-10 pr-10" data-id="element-171">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vqmDwVXp2N3EVA3cyDBGVE/Wavelet_Cmorlet.png" alt="Wavelet" className="w-auto h-[300px]" style={{
              filter: filterValue,
              transition: 'filter 0.3s ease'
            }} data-id="element-172" />
              </div>}
          </div>
        </div>
      </main>
    </div>;
};
export default ContactPage;